import type { RouteRecordRaw } from 'vue-router';

export const inventoryCategoryRoutes: Array<RouteRecordRaw> = [
  {
    path: '/inventory/category',
    name: 'inventoryCategory',
    redirect: '/inventory/category/list',
    component: () => import('pages/trade/admin/inventoryCategory/InventoryCategory.vue'),
    meta: {
      title: 'Inventory Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'inventoryCategoryList',
        component: () => import('pages/trade/admin/inventoryCategory/InventoryCategoryList.vue'),
        meta: {
          title: 'Inventory Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'inventoryCategoryDetail',
        component: () => import('pages/trade/admin/inventoryCategory/InventoryCategoryDetail.vue'),
        meta: {
          title: 'Inventory Category Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'inventoryCategoryNew',
        component: () => import('pages/trade/admin/inventoryCategory/InventoryCategoryNew.vue'),
        meta: {
          title: 'New Inventory Category',
          requiresAuth: true,
        },
      },
    ],
  },
];
